export function calcFee(amount) {
  // INR policy: free under Rs. 2,000, flat Rs. 6 above (matches Razorpay payout cost)
  const a = parseFloat(amount) || 0;
  return a < 2000 ? 0 : 6;
}

export function feeLabel(a) {
  a = parseFloat(a) || 0;
  return a < 2000 ? "Free" : "₹6 flat";
}

export function countdown(ms) {
  if (!ms) return "";
  const d = (ms.toDate ? ms.toDate().getTime() : ms) - Date.now();
  if (d <= 0) return "Released";
  return `${Math.floor(d / 3600000)}h ${Math.floor((d % 3600000) / 60000)}m`;
}

export function timeAgo(ts) {
  if (!ts) return "";
  const ms = ts.toDate ? ts.toDate().getTime() : (typeof ts === "number" ? ts : Date.now());
  const d  = Date.now() - ms;
  if (d < 60000)    return "just now";
  if (d < 3600000)  return `${Math.floor(d / 60000)}m ago`;
  if (d < 86400000) return `${Math.floor(d / 3600000)}h ago`;
  return `${Math.floor(d / 86400000)}d ago`;
}

export function uid() { return Date.now() + Math.random(); }
